import styled from "@emotion/styled";
import { Blac } from "blac-next";
import { useEffect } from "react";
import { getSupportedUserLanguage } from "src/lib/i18next";
import { getHeadingProps, useFocusHeading } from "src/lib/useFocusHeading";
import { KnownProgram } from "src/constants/programs";
import AppointmentsBloc from "src/state/AppointmentsBloc/AppointmentsBloc";
import TaskManagementBloc from "src/state/TaskManagementBloc/TaskManagementBloc";
import AppointmentsList from "src/ui/components/AppointmentsList/AppointmentsList";
import Branding from "src/ui/components/Branding/Branding";
import DailyReadingsWidget from "src/ui/components/DailyReadings/DailyReadingsWidget";
import MealInsightUploadCard from "src/ui/components/MealInsights/MealInsightUploadCard";
import PoweredByWidget from "src/ui/components/PoweredByWidget/PoweredByWidget";
import RxDietCard from "src/ui/components/RxDiet/RxDietCard";
import CollectionTitle from "src/ui/components/StyledComponents/CollectionTitle";
import TaskList from "src/ui/components/TaskList/TaskList";
import NotificationCard from "src/ui/components/NotificationCard/NotificationCard";
import Translate from "src/ui/components/Translate/Translate";
import UserEducationalFeed from "src/ui/components/UserEducationalFeed/UserEducationalFeed";
import UserEducationalFeedOld from "src/ui/components/UserEducationalFeed/UserEducationalFeedOld";
import NotificationBell from "src/ui/components/NotificationBell/NotificationBell";

const Wrap = styled.div`
  label: HomePageWrap;
  height: 100%;
`;

const Widgets = styled.div`
  label: HomePageWidgets;
  width: 100%;
  position: relative;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
`;

const WidgetRight = styled.div`
  label: WidgetRight;
  display: flex;
  align-items: center;
  gap: 0.8em;
  margin: 0.2rem 0 1.3rem auto;
`;

const HomePage = () => {
  const { headingRef } = useFocusHeading();
  const language = getSupportedUserLanguage();

  useEffect(() => {
    void Blac.getBloc(AppointmentsBloc).loadAppointments();
    void Blac.getBloc(TaskManagementBloc).loadProgramTasks(
      KnownProgram.ONBOARDING
    );
  }, []);

  return (
    <Wrap>
      <h1 className="only-sr" ref={headingRef} {...getHeadingProps()}>
        <Translate msg="homePage" />
      </h1>
      <Widgets>
        <PoweredByWidget />
        <WidgetRight>
          <DailyReadingsWidget />
          <NotificationBell mobile />
        </WidgetRight>
      </Widgets>

      <Branding
        style={{
          marginBlockEnd: "1.6em"
        }}
      />

      <NotificationCard />

      <AppointmentsList />

      <TaskList
        programs={[
          KnownProgram.ONBOARDING,
          KnownProgram.CARE,
          KnownProgram.MEAL_PLAN,
          KnownProgram.LIFEBALANCE,
          KnownProgram.BEHAVIORAL_HEALTH_SCREENING,
          KnownProgram.EDUCATION,
          KnownProgram.NUTRITION_JOURNEY,
          KnownProgram.MINDSET_JOURNEY,
          KnownProgram.PHYSICAL_ACTIVITY_JOURNEY,
          KnownProgram.EVERYDAY_DIABETES_JOURNEY
        ]}
        consolidateOnboardingTasks
      />

      <MealInsightUploadCard />

      <RxDietCard />

      <nine-spacer s="md" />
      <CollectionTitle>
        <Translate msg="articles.title" />
      </CollectionTitle>
      {language === "es" ? <UserEducationalFeedOld /> : <UserEducationalFeed />}
    </Wrap>
  );
};

export default HomePage;
